import { render, staticRenderFns } from "./CreateCoupon.vue?vue&type=template&id=86c42c7a&"
import script from "./CreateCoupon.vue?vue&type=script&lang=js&"
export * from "./CreateCoupon.vue?vue&type=script&lang=js&"
import style0 from "./CreateCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports